export const INCREASE_LOADING = 'INCREASE_LOADING';
export const DECREASE_LOADING = 'DECREASE_LOADING';
export const INCREASE_UPLOAD_LOADING = 'INCREASE_UPLOAD_LOADING';
export const DECREASE_UPLOAD_LOADING = 'DECREASE_UPLOAD_LOADING';
export const INCREASE_DETAILS_LOADING = 'INCREASE_DETAILS_LOADING';
export const DECREASE_DETAILS_LOADING = 'DECREASE_DETAILS_LOADING';

export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_CHECK_LOGGED = 'AUTH_CHECK_LOGGED';
export const AUTH_FORGOT_LOGIN = 'AUTH_FORGOT_LOGIN';
export const AUTH_CHANGE_PASSWORD = 'AUTH_CHANGE_PASSWORD';
export const AUTH_CHANGE_PASSWORD_ERROR = 'AUTH_CHANGE_PASSWORD_ERROR';
export const AUTH_UPDATE_USER_TOKEN = 'AUTH_UPDATE_USER_TOKEN';
export const AUTH_CHANGE_USER_CREDENTIAL = 'AUTH_CHANGE_USER_CREDENTIAL';
export const WARN_LOGIN_ATTEMPTS_ERROR = 'WARN_LOGIN_ATTEMPTS_ERROR';
export const SUCCESS_FORGOT_PASSWORD = 'SUCCESS_FORGOT_PASSWORD';
export const AUTH_CHANGE_USER_CREDENTIAL_ERROR =
  'AUTH_CHANGE_USER_CREDENTIAL_ERROR';
export const VALIDATE_TOKEN_SUCESS = 'VALIDATE_TOKEN_SUCESS';
export const SET_CREDENTIALS_ERROR = 'SET_CREDENTIALS_ERROR';
export const CLEAN_CREDENTIALS_ERROR = 'CLEAN_CREDENTIALS_ERROR';

export const USER_BALANCE = 'USER_BALANCE';
export const USER_SIDE_BALANCE = 'USER_SIDE_BALANCE';
export const USER_INCOME_TAX = 'USER_INCOME_TAX';
export const USER_EXPORT_DOWNLOAD_EXTRACT = 'USER_EXPORT_DOWNLOAD_EXTRACT';
export const CLEAN_BALANCE = 'CLEAN_BALANCE';
export const USER_BALANCE_REQUEST_ERROR = 'USER_BALANCE_REQUEST_ERROR';
export const USER_ACCOUNT_SPLIT_BALANCE = 'USER_ACCOUNT_SPLIT_BALANCE';

export const PROFILE_SELECTIVES = 'PROFILE_SELECTIVES';
export const ENTERPRISE_SELECTIVES = 'ENTERPRISE_SELECTIVES';

export const NOTIFICATION_REPORT = 'NOTIFICATION_REPORT';

export const GET_APPROVE_TRANSACTION = 'GET_APPROVE_TRANSACTION';
export const GET_APPROVE_TRANSACTION_BY_ID = 'GET_APPROVE_TRANSACTION_BY_ID';
export const GET_APPROVE_TRANSACTIONS_LIST = 'GET_APPROVE_TRANSACTIONS_LIST';
export const GET_EXECUTED_TRANSACTION = 'GET_EXECUTED_TRANSACTION';
export const GET_REPROVED_TRANSACTION = 'GET_REPROVED_TRANSACTION';
export const MULTIPLE_APPROVAL_SUCCESS = 'MULTIPLE_APPROVAL_SUCCESS';
export const MULTIPLE_APPROVAL_RESULT = 'MULTIPLE_APPROVAL_RESULT';

export const SET_ME = 'SET_ME';
export const SET_ISPB = 'SET_ISPB';
export const SET_USER_CONTRACT_TERMS = 'SET_USER_CONTRACT_TERMS';
export const SET_ROLES = 'SET_ROLES';
export const SET_PENDING_DOCUMENTS_ERROR = 'SET_PENDING_DOCUMENTS_ERROR';
export const SET_PENDING_DOCUMENTS = 'SET_PENDING_DOCUMENTS';
export const SET_PENDING_DOCUMENTS_UPLOAD_SUCCESS =
  'SET_PENDING_DOCUMENTS_UPLOAD_SUCCESS';
export const SET_PENDING_PIX_KEY_PORTABILITIES =
  'SET_PENDING_PIX_KEY_PORTABILITIES';
export const SET_CARDS_ELIGIBILITY = 'SET_CARDS_ELIGIBILITY';

export const SET_THEME = 'SET_THEME';
export const MY_USERS = 'MY_USERS';
export const MY_USERS_COUNT = 'MY_USERS_COUNT';
export const MY_OPERATORS = 'MY_OPERATORS';
export const CREATE_USER = 'CREATE_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const DELETE_USER = 'DELETE_USER';
export const UNSET_DELETE_USER = 'UNSET_DELETE_USER';
export const AVAILABLE_PERMISSIONS = 'AVAILABLE_PERMISSIONS';
export const GET_BY_ID_USER = 'GET_BY_ID_USER';
export const UPDATE_PERMISSIONS_USER = 'UPDATE_PERMISSIONS_USER';
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
export const USER_CONFIG = 'USER_CONFIG';
export const ACCOUNT_SWITCH = 'ACCOUNT_SWITCH';

export const SET_REMOTE_CONFIG = 'SET_REMOTE_CONFIG';
export const SET_SETTINGS = 'SET_SETTINGS';
export const SET_LOAN_SETTINGS = 'SET_LOAN_SETTINGS';
export const SET_SETTINGS_ERROR = 'SET_SETTINGS_ERROR';
export const SET_SETTINGS_SUCCESS = 'SET_SETTINGS_SUCCESS';
export const SET_SETTINGS_KEYS = 'SET_SETTINGS_KEYS';

export const FAQ_TOPICS = 'FAQ_TOPICS';
export const FAQ_TOPIC_QUESTIONS = 'FAQ_TOPIC_QUESTIONS';

export const FAQ_TOPIC = 'FAQ_TOPIC';
export const FAQ_TOPIC_QUESTION = 'FAQ_TOPIC_QUESTION';

export const BANK_LIST = 'BANK_LIST';
export const BANK_DETAILS = 'BANK_DETAILS';

export const FAVORED_CONTACT_LIST = 'FAVORED_CONTACT_LIST';
export const FAVORED_CONTACT_DELETE = 'FAVORED_CONTACT_DELETE';
export const FAVORED_CONTACT_FAVORITE = 'FAVORED_CONTACT_FAVORITE';

export const HOME_BALANCE = 'HOME_BALANCE';
export const HOME_TRANSACTIONS = 'HOME_TRANSACTIONS';
export const SET_HOME = 'SET_HOME';

export const TRANSFER_TRANSACTIONS = 'TRANSFER_TRANSACTIONS';
export const APPEND_TRANSACTIONS = 'APPEND_TRANSACTIONS';
export const TRANSACTION_DETAILS = 'TRANSACTION_DETAILS';
export const CLEAR_TRANSACTIONS = 'CLEAR_TRANSACTIONS';
export const SET_DAILY_BALANCE = 'SET_DAILY_BALANCE';

export const INCREASE_LOAD_BALANCE = 'INCREASE_LOAD_BALANCE';
export const DECREASE_LOAD_BALANCE = 'DECREASE_LOAD_BALANCE';

export const INCREASE_EXTRACT_LOAD = 'INCREASE_EXTRACT_LOAD';
export const DECREASE_EXTRACT_LOAD = 'DECREASE_EXTRACT_LOAD';

export const INCREASE_CARD_LOAD = 'INCREASE_CARD_LOAD';
export const DECREASE_CARD_LOAD = 'DECREASE_CARD_LOAD';

export const CONTACT_LIST = 'CONTACT_LIST';
export const SET_NEW_CONTACT = 'SET_NEW_CONTACT';

export const TRANSACTION_GET_BILLET = 'TRANSACTION_GET_BILLET';
export const GET_SCHEDULED_TRANSACTIONS = 'GET_SCHEDULED_TRANSACTIONS';
export const TRANSACTION_PAY_BILLET = 'TRANSACTION_PAY_BILLET';
export const TRANSACTION_GENERATE_BILLET_DETAILS =
  'TRANSACTION_GENERATE_BILLET_DETAILS';
export const TRANSACTION_GENERATE_QR_CODE = 'TRANSACTION_GENERATE_QR_CODE';
export const GET_LIMITS = 'GET_LIMITS';
export const UPDATE_LIMIT_STATUS = 'UPDATE_LIMIT_STATUS';
export const PIX_REGISTER_DETAILS = 'PIX_REGISTER_DETAILS';
export const PIX_GET_ALL_KEYS = 'PIX_GET_ALL_KEYS';
export const PIX_VERIFY_CODE_DETAILS = 'PIX_VERIFY_CODE_DETAILS';
export const PIX_PORTABILITY_SUCCESS = 'PIX_PORTABILITY_SUCCESS';
export const PIX_OWNERSHIP_CLAIM_SUCCESS = 'PIX_OWNERSHIP_SUCCESS';
export const PIX_OWNERSHIP_CLAIM_RESPONSE = 'PIX_OWNERSHIP_CLAIM_RESPONSE';
export const PIX_OWNERSHIP_CLAIM_RESPONSE_FALSE =
  'PIX_OWNERSHIP_CLAIM_RESPONSE_FALSE';
export const PIX_CANCEL_PORTABILITY_SUCCESS = 'PIX_CANCEL_PORTABILITY_SUCCESS';
export const PIX_DELETE_SUCCESS = 'PIX_DELETE_SUCCESS';
export const PIX_DECODE_QR_CODE = 'PIX_DECODE_QR_CODE';
export const SET_PIX_PSPS = 'SET_PIX_PSPS';
export const SET_PIX_PSP_ERROR = 'SET_PIX_PSP_ERROR';
export const SET_PIX_REVERSAL_REASONS = 'SET_PIX_REVERSAL_REASONS';

export const ONBOARDING_TAX_ID_STATUS = 'ONBOARDING_TAX_ID_STATUS';
export const ONBOARDING_CELLPHONE_STATUS = 'ONBOARDING_CELLPHONE_STATUS';
export const ONBOARDING_CNAE_DESCRIPTION = 'ONBOARDING_CNAE_DESCRIPTION';
export const ONBOARDING_CADASTRAL_SITUATION = 'ONBOARDING_CADASTRAL_SITUATION';
export const ONBOARDING_CNAE_CLEAR_STATUS = 'ONBOARDING_CNAE_CLEAR_STATUS';
export const ONBOARDING_LOGIN_STATUS = 'ONBOARDING_LOGIN_STATUS';
export const ONBOARDING_EMAIL_STATUS = 'ONBOARDING_EMAIL_STATUS';
export const ONBOARDING_CREATE_ACCOUNT = 'ONBOARDING_CREATE_ACCOUNT';
export const ONBOARDING_REGISTER_DEVICE = 'ONBOARDING_REGISTER_DEVICE';
export const ONBOARDING_VALIDATE_TOKEN = 'ONBOARDING_VALIDATE_TOKEN';
export const ONBOARDING_GET_ADDRESS = 'ONBOARDING_GET_ADDRESS';
export const ONBOARDING_GET_ADDRESS_ERROR = 'ONBOARDING_GET_ADDRESS_ERROR';
export const ONBOARDING_GET_REPRESENTANT_ADDRESS =
  'ONBOARDING_GET_REPRESENTANT_ADDRESS';
export const ONBOARDING_ADD_PARTNER = 'ONBOARDING_ADD_PARTNER';
export const ONBOARDING_TERMS_OF_USE = 'ONBOARDING_TERMS_OF_USE';
export const ONBOARDING_CREATE_ADDRESS = 'ONBOARDING_CREATE_ADDRESS';
export const ONBOARDING_GET_IMAGE_URL = 'ONBOARDING_GET_IMAGE_URL';
export const ONBOARDING_UPLOAD_DOCUMENT = 'ONBOARDING_UPLOAD_DOCUMENT';
export const ONBOARDING_SAVE_USER_PHOTO = 'ONBOARDING_SAVE_USER_PHOTO';
export const ONBOARDING_CUSTOM_DOCUMENT = 'ONBOARDING_CUSTOM_DOCUMENT';
export const ONBOARDING_SAVE_SOCIAL_CONTRACT =
  'ONBOARDING_SAVE_SOCIAL_CONTRACT';
export const ONBOARDING_SAVE_COMPANY_STATUTE =
  'ONBOARDING_SAVE_COMPANY_STATUTE';
export const ONBOARDING_SAVE_DECLARATION_BENEFICIARIES =
  'ONBOARDING_SAVE_DECLARATION_BENEFICIARIES';
export const ONBOARDING_SAVE_MINUTES_OF_ELECTION =
  'ONBOARDING_SAVE_MINUTES_OF_ELECTION';
export const ONBOARDING_SAVE_POWER_OF_ATTORNEY =
  'ONBOARDING_SAVE_POWER_OF_ATTORNEY';
export const ONBOARDING_SAVE_USER_DOCUMENT = 'ONBOARDING_SAVE_USER_DOCUMENT';
export const ONBOARDING_CLEAN_REPRESENTANT_DOCUMENT =
  'ONBOARDING_CLEAN_REPRESENTANT_DOCUMENT';
export const ONBOARDING_SAVE_REPRESENTANT_DOCUMENT =
  'ONBOARDING_SAVE_REPRESENTANT_DOCUMENT';
export const ONBOARDING_CREATE_PIN = 'ONBOARDING_CREATE_PIN';
export const ONBOARDING_SETTINGS = 'ONBOARDING_SETTINGS';
export const UPDATE_ONBOARDING_STATE = 'UPDATE_ONBOARDING_STATE';
export const ONBOARDING_CREATE_ACCOUNT_ERROR =
  'ONBOARDING_CREATE_ACCOUNT_ERROR';
export const SET_INVITE_RESPONSE = 'SET_INVITE_RESPONSE';
export const SET_ONBOARDING_CAF_INFO = 'SET_ONBOARDING_CAF_INFO';
export const SET_ONBOARDING_WEBVIEW_URL = 'SET_ONBOARDING_WEBVIEW_URL';
export const GET_ONBOARDING_WEBVIEW_URL_ERROR =
  'GET_ONBOARDING_WEBVIEW_URL_ERROR';

export const GET_CBO = 'GET_CBO';
export const GET_CBO_SUB_OCCUPATION = 'GET_CBO_SUB_OCCUPATION';
export const GET_CBO_SUB_SON_OCCUPATION = 'GET_CBO_SUB_SON_OCCUPATION';
export const GET_CBO_SUB_GRAND_CHILD = 'GET_CBO_SUB_GRAND_CHILD';
export const SET_CBO_ERROR = 'SET_CBO_ERROR';

export const GET_COUNTRIES = 'GET_COUNTRIES';
export const GET_STATES = 'GET_STATES';
export const GET_CITIES = 'GET_CITIES';
export const GET_CITIES_ERROR = 'GET_CITIES_ERROR';
export const GET_STATES_ERROR = 'GET_STATES_ERROR';
export const GET_COUNTRIES_ERROR = 'GET_COUNTRIES_ERROR';

export const SET_DETAILS = 'SET_DETAILS';
export const SET_DETAILS_ERROR = 'SET_DETAILS_ERROR';
export const UNSET_DETAILS = 'UNSET_DETAILS';

export const SET_DEVICE_ERROR = 'SET_DEVICE_ERROR';
export const GET_MY_DEVICES = 'GET_MY_DEVICES';
export const GET_MY_DEVICES_ERROR = 'GET_MY_DEVICES_ERROR';
export const DELETE_DEVICE = 'DELETE_DEVICE';
export const DELETE_DEVICE_ERROR = 'DELETE_DEVICE_ERROR';
export const BLOCK_DEVICE = 'BLOCK_DEVICE';
export const GET_DEVICE_COUNT = 'GET_DEVICE_COUNT';
export const GET_DEVICE_COUNT_ERROR = 'GET_DEVICE_COUNT_ERROR';
export const GET_REGISTER_INFORMATION = 'GET_REGISTER_INFORMATION';
export const GET_REGISTER_INFORMATION_ERROR = 'GET_REGISTER_INFORMATION_ERROR';

export const SET_CARRIERS = 'SET_CARRIERS';
export const SET_CARRIER_PRODUCT_LIST = 'SET_CARRIER_PRODUCT_LIST';
export const SET_RECHARGE_HISTORY = 'SET_RECHARGE_HISTORY';

export const SET_CARDS = 'SET_CARDS';
export const ADD_CARD = 'ADD_CARD';
export const UPDATE_CARD = 'UPDATE_CARD';
export const UPDATE_CARD_STATE = 'UPDATE_CARD_STATE';
export const UPDATE_CURRENT_CARD = 'UPDATE_CURRENT_CARD';
export const SET_CARD_SETTINGS = 'SET_CARD_SETTINGS';
export const SET_CARD_ERROR = 'SET_CARD_ERROR';
export const UNSET_CARD_ERROR = 'UNSET_CARD_ERROR';
export const SET_AVAILABLE_CARDS = 'SET_AVAILABLE_CARDS';
export const SET_HAS_CARDS = 'SET_HAS_CARDS';
export const GET_CARD_DETAILS = 'GET_CARD_DETAILS';
export const CLEAR_CARD_DETAILS = 'CLEAR_CARD_DETAILS';
export const PASSWORD_CARD = 'PASSWORD_CARD';
export const SET_CARD_TRACKING_INFO = 'SET_CARD_TRACKING_INFO';
export const REAL_CARD_DATA = 'REAL_CARD_DATA';
export const SET_ACCOUNT_STATUS = 'SET_ACCOUNT_STATUS';

export const CASHBACK_DETAILS = 'CASHBACK_DETAILS';
export const CASHBACK_REPORT = 'CASHBACK_REPORT';
export const CASHBACK_BALANCE = 'CASHBACK_BALANCE';
export const CASHBACK_BALANCE_MONEY = 'CASHBACK_BALANCE_MONEY';

export const PAYABLE_GROUP_REPORT = 'PAYABLE_GROUP_REPORT';
export const PAYABLE_REPORT = 'PAYABLE_REPORT';
export const PAYABLE_PREVIEW = 'PAYABLE_PREVIEW';

export const RECEIVABLE_GROUP_REPORT = 'RECEIVABLE_GROUP_REPORT';
export const RECEIVABLE_REPORT = 'RECEIVABLE_REPORT';
export const NEW_RECEIVABLE_REPORT = 'NEW_RECEIVABLE_REPORT';
export const RECEIVABLE_PREVIEW = 'RECEIVABLE_PREVIEW';
export const MANUAL_RECEIVABLE_ADDRESS = 'MANUAL_RECEIVABLE_ADDRESS';
export const RECEIVABLE_LINK = 'RECEIVABLE_LINK';
export const MANUAL_RECEIVABLE_RESULT = 'MANUAL_RECEIVABLE_RESULT';

export const SET_PRE_APPROVED_LOANS = 'SET_PRE_APPROVED_LOANS';
export const SET_LOAN = 'SET_LOAN';
export const SET_LOANS = 'SET_LOANS';
export const SET_LOAN_ERROR = 'SET_LOAN_ERROR';
export const SET_LOAN_SUCCESS = 'SET_LOAN_SUCCESS';
export const SET_LOAN_SIMULATION = 'SET_LOAN_SIMULATION';
export const SET_LOAN_EXTERNAL_SIMULATION = 'SET_LOAN_EXTERNAL_SIMULATION';

export const SET_PAY_STUB_LIST = 'SET_PAY_STUB_LIST';
export const SET_PAY_STUB_ERROR = 'SET_PAY_STUB_ERROR';
export const SET_PAY_STUB_SUCCESS = 'SET_PAY_STUB_SUCCESS';
export const SET_PAY_STUB_DETAIL = 'SET_PAY_STUB_DETAIL';
export const USER_EXPORT_DOWNLOAD_PAY_STUB = 'USER_EXPORT_DOWNLOAD_PAY_STUB';

export const SET_SALARY_PORTABILITY_FAVORED = 'SET_SALARY_PORTABILITY_FAVORED';
export const SET_SALARY_PORTABILITY_ERROR = 'SET_SALARY_PORTABILITY_ERROR';
export const SET_SALARY_PORTABILITY_SUCCESS = 'SET_SALARY_PORTABILITY_SUCCESS';

export const INVESTMENT_POSITION_REPORT = 'INVESTMENT_POSITION_REPORT';
export const INVESTMENTS_REPORT = 'INVESTMENTS_REPORT';
export const CDB_INVESTMENTS = 'CDB_INVESTMENTS';
export const LCA_INVESTMENTS = 'LCA_INVESTMENTS';
export const LCI_INVESTMENTS = 'LCI_INVESTMENTS';
export const INVESTMENT_PRODUCT_DETAIL = 'INVESTMENT_PRODUCT_DETAIL';
export const INVESTMENT_APPLICATIONS = 'INVESTMENT_APPLICATIONS';
export const INVESTMENT_APPLICATION_DETAILS = 'INVESTMENT_APPLICATION_DETAILS';
export const INVESTMENT_APPLICATION_STATEMENT =
  'INVESTMENT_APPLICATION_STATEMENT';

export const INVESTMENT_APPLICATION_STATEMENT_DETAILS =
  'INVESTMENT_APPLICATION_STATEMENT_DETAILS';

export const SET_LIST_ALL_GROUP = 'SET_LIST_ALL_GROUP';
export const CREATE_GROUP = 'CREATE_GROUP';
export const CREATE_OPERATOR = 'CREATE_OPERATOR';
export const EDIT_GROUP = 'EDIT_OPERATOR';
export const IS_EDIT = 'IS_EDIT';
export const GET_GROUP_FOR_ID = 'GET_GROUP_FOR_ID';

export const UNSET_CREATE_GROUP = 'UNSET_CREATE_GROUP';
export const UNSET_CREATE_OPERATOR = 'UNSET_CREATE_OPERATOR';
export const UNSET_EDIT_GROUP = 'UNSER_EDIT_GROUP';

export const SET_TOTP_TYPE_VALIDATION = 'SET_TOTP_FLOW';
export const SET_ERROR_PIN_FOR_TOTP = 'SET_ERROR_PIN_FOR_TOTP';
export const SET_SUCCESS_PIN_FOR_TOTP = 'SET_SUCCESS_PIN_FOR_TOTP';
export const SEND_TOTP_FOR_USER = 'SEND_TOTP_FOR_USER';
export const SEND_TOTP_FOR_USER_ERROR = 'SEND_TOTP_FOR_USER_ERROR';

export const NEED_CREATE_IN_COREBANKING = 'NEED_CREATE_IN_COREBANKING';
export const SET_CREATED_IN_COREBANK = 'SET_CREATED_IN_COREBANK';
export const UNSET_CREATED_IN_COREBANK = 'UNSET_CREATED_IN_COREBANK';
export const SET_OPERATOR_STATIC_VALUE = 'SET_OPERATOR_STATIC_VALUE';

export const SET_BILLET_REMIT = 'SET_BILLET_REMIT';
export const SET_PIX_REMIT = 'SET_PIX_REMIT';
export const SET_TRANSFER_REMIT = 'SET_TRANSFER_REMIT';
export const EMPLOYEES_LIST = 'EMPLOYEES_LIST';
export const EMPLOYEES_UPLOAD_LOG = 'EMPLOYEES_UPLOAD_LOG';
export const EMPLOYEES_PAYMENT_STATUS = 'EMPLOYEES_PAYMENT_STATUS';
export const EMPLOYEES_PAYMENT_LIST = 'EMPLOYEES_PAYMENT_LIST';
export const CLEAN_PAYMENT_STATUS = 'CLEAN_PAYMENT_STATUS';
export const PAYMENT_APPROVAL_SUCCESS = 'PAYMENT_APPROVAL_SUCCESS';
export const CLEAN_APPROVAL_STATUS = 'CLEAN_APPROVAL_STATUS';
export const EMPLOYEE_TRANSACTION_LIST = 'EMPLOYEE_TRANSACTION_LIST';
export const SET_DOWNLOAD_RECEIPT_LIST = 'SET_DOWNLOAD_RECEIPT_LIST';
export const EMPLOYEE_ACCOUNT_DETAIL = 'EMPLOYEE_ACCOUNT_DETAIL';
export const EASY_CREDIT_LIST = 'EASY_CREDIT_LIST';

export const PAYMENT_TYPES = 'PAYMENT_TYPES';

export const SET_PAYMENT_ACCOUNT_ID = 'SET_PAYMENT_ACCOUNT_ID';

export const CONDOMINIUMS_LIST = 'CONDOMINIUMS_LIST';
export const CONDOMINIUMS_UPLOAD_LIST = 'CONDOMINIUMS_UPLOAD_LIST';
export const CONDOMINIUMS_UPLOAD_STATUS = 'CONDOMINIUMS_UPLOAD_STATUS';
export const CLEAN_UPLOAD_STATUS_CONDOMINIUMS =
  'CLEAN_UPLOAD_STATUS_CONDOMINIUMS';
export const CONDOMINIUM_IS_LOGGED = 'CONDOMINIUM_IS_LOGGED';

export const PAYSLIP_PREVIEW = 'PAYSLIP_PREVIEW';
export const PAYSLIP_GROUP_REPORT = 'PAYSLIP_GROUP_REPORT';
export const PAYSLIP_GROUP_DETAILS = 'PAYSLIP_GROUP_DETAILS';

export const SET_OVERDRAFT_INFO = 'SET_OVERDRAFT_INFO';
export const USER_IMPERSONATION_LIST = 'USER_IMPERSONATION_LIST';
export const USER_IMPERSONATION_LAST_ACCESS = 'USER_IMPERSONATION_LAST_ACCESS';

export const PRODUCTS_ALREADY_CREATED_ESCROW_ACCOUNT =
  'PRODUCTS_ALREADY_CREATED_ESCROW_ACCOUNT';
export const PRODUCTS_ESCROW_ACCOUNT = 'PRODUCTS_ESCROW_ACCOUNT';
export const PRODUCTS_ESCROW_TRANSACTIONS = 'PRODUCTS_ESCROW_TRANSACTIONS';
export const PRODUCTS_LIMIT_SOLICITATIONS = 'PRODUCTS_LIMIT_SOLICITATIONS';
